import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum, CalculationMethodType, TimeUnit } from "__generated__/graphql";

export const DailySchema: RegistryItem = {
	[AgreementTypeEnum.Daily]: {
		defaultValues: {
			calculationMethod: {
				type: CalculationMethodType.TimeUnit,
				timeUnit: TimeUnit.Day,
			},
		},
		agreementFields: {
			"agreement.manualActionRequired": { rules: { hidden: true } },
			"agreement.conditions": { rules: { hidden: true } },
		},
		calculationMethodFields: {
			"calculationMethod.type": { rules: { hidden: true } },
			"calculationMethod.timeUnit": { rules: { hidden: true } },
			"calculationMethod.minimumTimeUnitsPayable": { rules: { hidden: true } },
		},
	},
};
